import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row, Table, Pagination, Modal, Button } from "react-bootstrap";
import {
  defaultPoint, FilterUsersDto,
  FormPayload,
  FormSubmission,
  NotesResponse,
  Point,
  SubmissionNotes
} from "../../../../service/types/types";
import { useParams } from "react-router-dom";
import { FormsService } from "../../../../service/forms.service";
import { SubmissionsService } from "../../../../service/submission.service";
import { GMapSelector } from "../../../common/predios/GMapSelector";
import {UserService} from "../../../../service/users.service";
import {PrediosService} from "../../../../service/predios.service";
import Select from "react-select";
import {getHighestRole} from "../../../../service/utils/accessUtils";

export default function FormResults() {
  const { id } = useParams<{ id: string }>();
  const [form, setForm] = useState<FormPayload | null>(null);
  const [fieldMap, setFieldMap] = useState<Map<number, string>>(new Map());
  const [submissions, setSubmissions] = useState<FormSubmission[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [fromDate, setFromDate] = useState<string>(() => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date.toISOString().split('T')[0];
  });
  const [toDate, setToDate] = useState<string>("");
  const [rut, setRut] = useState<string>("");
  const itemsPerPage = 7; // 👈 cantidad de filas por página

  const [usersOptions, setUsersOptions] = useState<{ value: string; label: string; }[]>([]);

  //Modal
  const [show, setShow] = useState(false);
  const [map, setMap] = useState<Point>(defaultPoint);
  const handleClose = () => setShow(false);
  const handleShow = (location: any) =>{
    const coords = JSON.parse(location) as { lat: number; lng: number };
    setMap(prev => ({
      ...prev,
      coordinates: [coords.lng, coords.lat], // 👈 actualizas solo coordinates
    }));
    setShow(true)
  };

  // Modal para notas
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [selectedNotes, setSelectedNotes] = useState<NotesResponse[]>([]);
  const handleCloseNotesModal = () => setShowNotesModal(false);
  const handleShowNotesModal = (notes: NotesResponse[] | undefined) => {
    if (notes && notes.length > 0) {
      setSelectedNotes(notes);
      setShowNotesModal(true);
    }
  };

  const handleDownloadPdf = async (id: string) => {
    try {
      const blob = await SubmissionsService.downloadPdf(id);
      if (blob && blob.size > 0) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `submission-${id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        alert("Error al descargar PDF: archivo vacío");
      }
    } catch (error) {
      console.error("Error descargando PDF:", error);
      alert("Error al descargar PDF");
    }
  };


  // Modal para imagen ampliada
  const [showImageModal, setShowImageModal] = useState(false);
  const [expandedImage, setExpandedImage] = useState<string>("");
  const handleCloseImageModal = () => setShowImageModal(false);
  const handleShowImageModal = (imageUrl: string) => {
    setExpandedImage(imageUrl);
    setShowImageModal(true);
  };
  useEffect(() => {
    const fetchUsers = async () => {
     try {
        const data = await UserService.findAll();
        const options = data.map(user => ({
          value: user.rut,
          label: `${user.name} (${user.rut})`,
        }));
        setUsersOptions(options);
      } catch (error) {
       console.error('Error fetching users:', error);
      }
    }
    if(getHighestRole() === "ADMIN") {
      fetchUsers();
    }
  }, []);

  useEffect(() => {
    const fetchForm = async () => {
      if (!id) return;
      const data = await FormsService.findById(id);
      setForm(data);
      if (data) {
        let currentRut = rut;
        if(getHighestRole() === "WORKER") {
          currentRut = localStorage.getItem("rut") || "";
        }
        const submissions = await SubmissionsService.findByForm(data.id, fromDate, toDate, currentRut);
        setSubmissions(submissions);
        const fieldMap = new Map();
        
        let count = 0;
        data.fields.forEach(field => {
          fieldMap.set(count, field.id);
          count++;
        })
        setFieldMap(fieldMap);
      }
    };
    fetchForm();
  }, [id, fromDate, toDate, rut]);

  // Calcular índices de paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentSubmissions = submissions.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(submissions.length / itemsPerPage);

    // UI del filtro (from / to + botones)
  return (
    <>
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton/>
      <Modal.Body>
        <GMapSelector
          initialCenter={map.coordinates}
          onSelect={() => {}}
          isReadOnly = {true}
        />
      </Modal.Body>
    </Modal>

    {/* Modal para Notas */}
    <Modal show={showNotesModal} onHide={handleCloseNotesModal} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Notas ({selectedNotes.length})</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {selectedNotes.map((note, index) => (
            <Card key={index} className="mb-3">
              <Card.Body>
                <h6>Nota {index + 1}</h6>
                <p className="mb-2"><strong>Texto:</strong></p>
                <p className="mb-3">{note.note_text}</p>
                {note.location &&
                  <div key={index} className="text-center">
                    <button className="btn btn-sm btn-primary" onClick={() => handleShow(note.location)}>
                      Ver Ubicación
                    </button>
                  </div>
                }
                {note.image_url && (
                  <div>
                    <p><strong>Imagen:</strong></p>
                    <div className="text-center">
                      <img
                        src={"/api" + note.image_url}
                        alt={`Nota ${index + 1}`}
                        style={{
                          maxWidth: "300px",
                          maxHeight: "300px",
                          borderRadius: "4px",
                          cursor: "pointer",
                          border: "1px solid #ddd",
                          padding: "4px"
                        }}
                        onClick={() => handleShowImageModal(note.image_url)}
                      />
                      <p className="mt-2 text-muted small">Haz clic en la imagen para ampliar</p>
                    </div>
                  </div>
                )}
              </Card.Body>
            </Card>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseNotesModal}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>

    {/* Modal para Imagen Ampliada */}
    <Modal show={showImageModal} onHide={handleCloseImageModal} size="xl" centered fullscreen="sm-down">
      <Modal.Header closeButton>
        <Modal.Title>Imagen Ampliada</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
        <img
          src={expandedImage}
          alt="Imagen ampliada"
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            borderRadius: "4px"
          }}
        />
      </Modal.Body>
    </Modal>
    <Container className="mt-4">
      <div className="mb-3 d-flex flex-wrap align-items-end gap-2">
      <div>
        <label className="form-label mb-1">Desde</label>
        <input
          type="date"
          className="form-control"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />
      </div>

      <div>
        <label className="form-label mb-1">Hasta</label>
        <input
          type="date"
          className="form-control"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />
      </div>
      { getHighestRole() === "ADMIN" && (
          <div style={{ minWidth: '250px', maxWidth: '400px'}}>
            <label className="form-label mb-1">Usuario</label>
            <Select
                options={usersOptions}
                onChange={(options) => setRut(options?.value || "")}
                placeholder="Escribe para buscar..."
                isSearchable
                styles={{
                  container: (base) => ({ ...base, width: '100%' }),
                }}
            />
          </div>
      )}

    </div>
      <Row className="justify-content-center">
        <Col md={12}>
          <Card className="mt-4 shadow-sm">
            <Card.Header className="bg-primary text-white">
              <h4 className="mb-0">{form?.name}</h4>
            </Card.Header>
            <Card.Body>
              <Table striped bordered hover responsive>
                <thead className="table-light">
                  <tr>
                    <th>Fecha envío</th>
                    <th>Enviado Por</th>
                    {form?.fields.map((field) => (
                      <th key={field.id}>{field.label}</th>
                    ))}
                    {form?.isSignRequired && <th>Firma</th>}
                    <th>Notas</th>
                    <th>descargar</th>
                  </tr>
                </thead>
                <tbody>
                  {currentSubmissions.map((submission) => (
                    <tr key={submission.id}>
                      <td>{new Date(submission.submittedAt).toLocaleString()}</td>
                      <td>{submission.rut}</td>
                      {form?.fields.map((field) => {
                        const value = submission.values.find(v => v.fieldId == field.id)?.value;
                        if(field.type === "location" && value){
                          return (
                            <td key={field.id} className="text-center">
                              <button className="btn btn-sm btn-primary" onClick={() => handleShow(value)}>
                                Ver
                              </button>
                            </td>
                          )
                        } else if(field.type === "files" && value){
                          const filePaths = value.split(",").map((path) => path.trim());
                          return (
                            <td key={field.id}>
                              {filePaths.map((path, idx) => (
                                <a
                                  key={idx}
                                  href={"/api" + path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginRight: "8px" }}
                                >
                                  {idx + 1}
                                </a>
                              ))}
                            </td>
                          );
                        }
                         else {
                          return <td key={field.id}>{value}</td>;
                        }
                      })}
                      {form?.isSignRequired && <td>{submission.signature ? (
                          <img
                            src={`${submission.signature}`}
                            alt="Firma"
                            style={{ maxWidth: "250px", maxHeight: "120px" }}
                          />
                        ) : (
                          "-"
                        )} </td>}
                      <td className="text-center">
                        {submission.notes && submission.notes.length > 0 ? (
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => handleShowNotesModal(submission.notes)}
                          >
                            Ver Notas ({submission.notes.length})
                          </Button>
                        ) : (
                          <span className="text-muted">Sin notas</span>
                        )}
                      </td>
                      <td className="text-center">
                        <Button
                                variant="danger"
                                size="sm"
                                onClick={() => handleDownloadPdf(submission.id)}
                            >
                                Descargar PDF
                        </Button>
                      </td>
                    </tr>
                  ))}
                  {submissions.length === 0 && (
                    <tr>
                      <td
                        colSpan={form?.fields?.length ? form.fields.length + 5 : 3}
                        className="text-center text-muted"
                      >
                        No hay resultados disponibles
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {/* 📌 Paginación */}
              {totalPages > 1 && (
                <Pagination className="justify-content-center">
                  <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                  <Pagination.Prev
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                  />
                  {[...Array(totalPages)].map((_, idx) => (
                    <Pagination.Item
                      key={idx + 1}
                      active={idx + 1 === currentPage}
                      onClick={() => setCurrentPage(idx + 1)}
                    >
                      {idx + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last
                    onClick={() => setCurrentPage(totalPages)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </>
  );
}